import React from 'react';
import { ConnectUrbanSports } from './ConnectUrbanSports';
import { USCConnectContextProvider } from './UrbanSportsConnectContext';

export const USCConnectWrapper = () => (
  <USCConnectContextProvider>
    <ConnectUrbanSports />
  </USCConnectContextProvider>
);
